import React from "react";
import {
  Box,
  Table,
  Text,
  HStack,
  Tag,
  VStack,
} from "@chakra-ui/react";
import { useSelector } from "react-redux";

import TicketsPerServiceLineGraph from "../../charts/daily/TicketsPerServiceLineGraph";
import TicketsPerServicePieGraph from "../../charts/TicketsPerServicePieGraph";

const { formatNumber, formatPercent } = require("../../../../store/helpers");

const OrganizationTicketsPerServiceTable = ({
  branchId = null,
  data,
  
  branchIndex,
  branchName,
  numServices,
}) => {
  const { showEmptyDataSets } = useSelector((state) => state.defaultReducer);

  let chartTitle = "Entire Organization,";
  if (branchId) {
    chartTitle = `${branchName} Branch`;
  }

  const branchTitle = branchId
    ? ` ${
        branchIndex ? branchIndex + ". " : ""
      }${branchName} Branch`
    : "Entire Organization";

  return (
    <Box mt={10}>
      {branchId ? (
        <Box mb="20px">
          <h2>{branchTitle}</h2>
          <p>{numServices} services.</p>
        </Box>
      ) : (
        <Box mb="20px">
          <h2>1. Entire Organization</h2>
        </Box>
      )}
      {data.map((a, index) => {
        return (
          <Box key={index} className="reportContainer" mt="20px">
            <Box mb="10px">
              <h3>
                {branchIndex ? branchIndex + ". " : null}
                {index + 1}. {a.name}
              </h3>
              {branchId ? (
                <Tag.Root>
                  <Tag.Label className="branchTag">{branchName} Branch</Tag.Label>
                </Tag.Root>
              ) : null}
            </Box>
            {showEmptyDataSets ||
            (!showEmptyDataSets && Number(a.total) > 0) ? (
              <Table.Root className="stripedTable" size="sm">
                <Table.Header>
                  <Table.Row>
                    <Table.ColumnHeader borderRight="1px solid #dadce0">Total Tickets</Table.ColumnHeader>
                    <Table.ColumnHeader>Avg /hour.</Table.ColumnHeader>
                    <Table.ColumnHeader>Min.</Table.ColumnHeader>
                    <Table.ColumnHeader borderRight="1px solid #dadce0">Max</Table.ColumnHeader>
                    <Table.ColumnHeader>Completed</Table.ColumnHeader>
                    <Table.ColumnHeader>No Show</Table.ColumnHeader>
                    <Table.ColumnHeader>Unattended</Table.ColumnHeader>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  <Table.Row>
                    <Table.Cell borderRight="1px solid #dadce0">
                      <Text color={"var(--blue)"}>{formatNumber(a.total)}</Text>
                    </Table.Cell>
                    <Table.Cell>
                      <Text>{formatNumber(a.averageTicketsPerHour)}</Text>
                    </Table.Cell>
                    <Table.Cell>
                      <Text>{formatNumber(a.minTicketsPerHour)}</Text>
                    </Table.Cell>
                    <Table.Cell borderRight="1px solid #dadce0">
                      <Text>{formatNumber(a.maxTicketsPerHour)}</Text>
                    </Table.Cell>
                    <Table.Cell>
                      <VStack gap="2px" alignItems="flex-start">
                        <Text color={"var(--green)"}>
                          {formatNumber(a.completed)}
                        </Text>
                        <Box
                          color="gray.500"
                          fontWeight="semibold"
                          fontSize="xs"
                          textTransform="uppercase"
                        >
                          ({formatPercent(a.pctCompleted)})
                        </Box>
                      </VStack>
                    </Table.Cell>
                    <Table.Cell>
                      <VStack gap="2px" alignItems="flex-start">
                        <Text cursor="pointer" color={"var(--red)"}>
                          {formatNumber(a.noShow)}
                        </Text>
                        <Box
                          color="gray.500"
                          fontWeight="semibold"
                          fontSize="xs"
                          textTransform="uppercase"
                        >
                          ({formatPercent(a.pctNoShow)})
                        </Box>
                      </VStack>
                    </Table.Cell>
                    <Table.Cell>
                      <VStack gap="2px" alignItems="flex-start">
                        <Text color={"var(--red)"}>
                          {formatNumber(a.unattended)}
                        </Text>
                        <Box
                          color="gray.500"
                          fontWeight="semibold"
                          fontSize="xs"
                          textTransform="uppercase"
                        >
                          ({formatPercent(a.pctUnattended)})
                        </Box>
                      </VStack>
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell colSpan={9} p={0}>
                      <HStack>
                        <Box w="30%">
                          <TicketsPerServicePieGraph
                            title={`Ticket Management Comparison`}
                            chart={a}
                            chartHeight="200px"
                          />
                        </Box>
                        <Box w="70%" key={3423}>
                          <TicketsPerServiceLineGraph
                            title={`${a.name}: ${chartTitle} Hour by Hour Comparison`}
                            chart={a.hours}
                            chartHeight="200px"
                          />
                        </Box>
                      </HStack>
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table.Root>
            ) : (
              <Text fontSize="sm">No data available for this report</Text>
            )}
          </Box>
        );
      })}
    </Box>
  );
};

export default OrganizationTicketsPerServiceTable;
